import React, { useContext, useEffect, useState } from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import MonthlySelectionTrends from "./MonthlySelectionTrends";
import DashBoardCandidateChart from "./DashBoardCandidateChart";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import LoadingSpinner from "../loader/loadercomp";
import { postItem } from "../../BaseUrl";
import { GETDASHBOARDDATA } from "./Mutation";
import ExportDialog from "../Utils/ExportDialog";
import FilterDialog from "../Utils/FilterDialog";
import { UserContext } from "../usercontext/usercontext";
import colors from "../../assest/theme/base/colors";
import Grid from "@mui/material/Grid2";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import MessagePopup from "../Utils/MessagePopup";

// Register necessary Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartTooltip,
  Legend
);

const Dashboard = () => {
  const { isuser } = useContext(UserContext);
  const { user } = useContext(UserContext);
  const [searchdata, setsearchdata] = useState("");
  const [openExport, setOpenExport] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [showbutton, setshowbutton] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [fileterdownloadurl, setFileterdownloadurl] = useState('');
  const [fileterdownloadurlCSV, setFileterdownloadurlCSV] = useState('');
  const [dashboardData, setDashboardData] = useState([]);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    fromDateStatus: "unchecked",
    toDateStatus: "unchecked",
  });

const dashboardChartData = dashboardData?.statusCounts || [];
  const shortlisted =
    dashboardChartData.find((item) => item.status === "shortlisted")?.count ||
    0;
  const interviewed =
    dashboardChartData.find((item) => item.status === "interviewed")?.count ||
    0;
  const onboarded =
    dashboardChartData.find((item) => item.status === "onboarded")?.count || 0;

  const exportClose = () => {
    setOpenExport(false);
  };

  const filterClose = () => {
    setOpenFilter(false);
    // resetForm()
  };

  const FormClosewithreset = () => {
    setOpenFilter(false);
    resetForm();
  };

  const resetForm = () => {
    setFilterData({
      fromDate: "",
      toDate: "",
      fromDateStatus: "unchecked",
      toDateStatus: "unchecked",
    });
  };

  const mapCandidateData = (list) => {
    return list.map((item) => ({
      id: item.id || "N/A",
      candidateName: item.candidateName || "N/A",
      status: item.status || "N/A",
      positionName: item.position?.positionName || "N/A",
      clientName: item.client?.clientName || "N/A",
    }));
  };

  const processFilterAllData = (filterAllData) => {
    const screeningData = mapCandidateData(filterAllData.screeningList || []);
    const interviewData = mapCandidateData(filterAllData.interviewList || []);
    const onboardingData = mapCandidateData(filterAllData.onboardingList || []);

    return {
      summaryStats: filterAllData.summaryStats || {},
      statusCounts: filterAllData.statusCounts || [],
      monthlyOnboardedCounts: filterAllData.monthlyOnboardedCounts || [],
      screeningData,
      interviewData,
      onboardingData,
    };
  };

  const exportData = processFilterAllData(dashboardData);

  // Mock data
  const stats = [
    {
      label: "Total Candidates Entered",
      value: dashboardData?.summaryStats?.totalEnteredByHr,
      icon: (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7249 12.3083C17.5849 12.3083 16.5149 12.5383 15.6149 12.9283C18.7649 13.8383 20.9949 16.0183 21.0549 18.5683C22.6949 18.3583 24.4649 17.7384 24.4649 16.0484C24.4649 14.0184 21.8349 12.3083 18.7249 12.3083Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6949 10.8684H18.7149C20.8449 10.8684 22.5849 9.12843 22.5849 7.00843C22.5849 4.87843 20.8449 3.13843 18.7149 3.13843C18.2949 3.13843 17.8949 3.20843 17.5149 3.32843C18.2049 4.34843 18.6049 5.57843 18.6049 6.90843C18.6149 8.25843 18.1949 9.55843 17.4049 10.6384C17.8149 10.7884 18.2449 10.8684 18.6949 10.8684Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.87491 12.9183C7.97491 12.5383 6.90491 12.3083 5.77491 12.3083C2.66491 12.3083 0.0349121 14.0184 0.0349121 16.0484C0.0349121 17.7384 1.79491 18.3483 3.43491 18.5683C3.48491 16.0183 5.71491 13.8383 8.87491 12.9183Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.77492 10.8684H5.80492C6.25492 10.8684 6.68492 10.7884 7.09492 10.6384C6.33492 9.59843 5.88492 8.30843 5.88492 6.90843C5.88492 5.57843 6.28492 4.34843 6.97492 3.32843C6.59492 3.20843 6.19492 3.13843 5.77492 3.13843C3.64492 3.13843 1.91492 4.87843 1.91492 7.00843C1.91492 9.12843 3.64492 10.8684 5.77492 10.8684Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2445 13.9454C8.28352 13.9454 4.93652 16.1014 4.93652 18.6534C4.93652 21.9534 10.4365 21.9534 12.2445 21.9534C15.3825 21.9534 19.5545 21.6134 19.5545 18.6744C19.5545 16.1104 16.2065 13.9454 12.2445 13.9454Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2455 11.7745H12.2785C13.5735 11.7705 14.7895 11.2615 15.7015 10.3425C16.6145 9.42351 17.1145 8.20451 17.1095 6.91151C17.1095 4.22851 14.9285 2.04651 12.2455 2.04651C9.56351 2.04651 7.38251 4.22851 7.38251 6.91151C7.38251 9.59251 9.56351 11.7745 12.2455 11.7745Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      label: "Total Shortlisted Candidates",
      value: shortlisted,
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5031 12.9938C24.089 12.9938 27 10.0828 27 6.49688C27 2.91094 24.089 0 20.5031 0C16.9172 0 14.0062 2.91094 14.0062 6.49688C14.0484 10.0828 16.9594 12.9938 20.5031 12.9938ZM20.5031 1.18125C23.4562 1.18125 25.8187 3.58594 25.8187 6.49688C25.8187 9.40781 23.414 11.8125 20.5031 11.8125C17.5922 11.8125 15.1875 9.40781 15.1875 6.49688C15.1875 3.58594 17.5922 1.18125 20.5031 1.18125Z"
            fill="white"
          />
          <path
            d="M18.8578 9.02808C18.9844 9.15464 19.1109 9.19683 19.2797 9.19683C19.4484 9.19683 19.575 9.15464 19.7016 9.02808L23.9625 4.76714C24.1734 4.5562 24.1734 4.17651 23.9625 3.92339C23.8359 3.79683 23.7094 3.75464 23.5406 3.75464C23.3719 3.75464 23.2453 3.79683 23.1188 3.92339L19.2375 7.80464L17.9297 6.49683C17.8031 6.37026 17.6766 6.32808 17.5078 6.32808C17.3391 6.32808 17.2125 6.37026 17.0859 6.49683C16.875 6.70776 16.875 7.08745 17.0859 7.34058L18.8578 9.02808Z"
            fill="white"
          />
          <path
            d="M6.49688 0.0422363C2.91094 0.0422363 0 2.91099 0 6.49692C0 8.2688 0.717188 9.82974 1.85625 11.011L1.89844 11.0532C3.07969 12.2344 4.68281 12.9516 6.45469 12.9516C8.26875 12.9516 9.87188 12.2344 11.0531 11.0532C12.1922 9.87192 12.9094 8.2688 12.9094 6.49692C12.9516 2.91099 10.0406 0.0422363 6.49688 0.0422363ZM10.8422 9.53442C10.8 9.57661 10.7578 9.66099 10.7156 9.70317C10.6734 9.78755 10.5891 9.82974 10.5469 9.91411C10.2938 9.49224 9.91406 9.19692 9.49219 9.02817C9.02813 8.90161 8.52188 8.64849 7.88906 8.31099L7.67813 8.18442L7.80469 8.01567C7.97344 7.76255 8.1 7.46724 8.22656 7.17192V7.08755L8.26875 7.04536C8.56406 6.83442 8.69063 6.41255 8.73281 6.15942C8.81719 5.82192 8.73281 5.52661 8.52188 5.35786L8.4375 5.27349V4.97817C8.47969 4.47192 8.31094 4.00786 7.97344 3.67036C7.63594 3.29067 7.12969 3.12192 6.58125 3.12192H6.24375C5.69531 3.12192 5.18906 3.33286 4.85156 3.67036C4.51406 4.00786 4.34531 4.47192 4.3875 4.97817V5.27349L4.30313 5.35786C4.09219 5.52661 4.00781 5.77974 4.09219 6.15942C4.13438 6.45474 4.30313 6.87661 4.55625 7.04536L4.59844 7.08755V7.17192C4.68281 7.50942 4.85156 7.80474 5.02031 8.01567L5.14688 8.18442L5.0625 8.31099C4.42969 8.64849 3.92344 8.90161 3.45938 9.02817C2.99531 9.15474 2.65781 9.45005 2.3625 9.91411C2.32031 9.82974 2.23594 9.78755 2.19375 9.70317C2.15156 9.66099 2.10938 9.57661 2.06719 9.53442C1.47656 8.69067 1.13906 7.63599 1.13906 6.49692C1.13906 3.5438 3.54375 1.1813 6.45469 1.1813C9.40781 1.1813 11.8125 3.58599 11.8125 6.49692C11.8125 7.63599 11.4328 8.64849 10.8422 9.53442Z"
            fill="white"
          />
          <path
            d="M6.49688 13.5844C2.91094 13.5844 0 16.4953 0 20.0812C0 21.8531 0.717188 23.414 1.81406 24.5953C1.81406 24.6375 1.85625 24.6375 1.89844 24.6797C3.07969 25.8609 4.68281 26.5781 6.45469 26.5781C8.22656 26.5781 9.87188 25.8609 11.0531 24.6797C12.2344 23.4984 11.0953 24.6375 11.0953 24.6375C11.0953 24.6375 11.0953 24.6375 11.0953 24.5953C12.2344 23.414 12.9094 21.8531 12.9094 20.0812C12.9516 16.4953 10.0406 13.5844 6.49688 13.5844ZM10.8422 23.1187C10.8 23.1609 10.7578 23.2453 10.7156 23.2875C10.6734 23.3719 10.5891 23.414 10.5469 23.4984C10.2938 23.0344 9.91406 22.739 9.49219 22.6125C8.90156 22.4437 8.31094 22.1062 7.88906 21.8953L7.67813 21.7687L7.80469 21.6C7.97344 21.3469 8.1 21.0937 8.22656 20.7562V20.6719L8.26875 20.6297C8.56406 20.4187 8.69063 19.9547 8.73281 19.7859V19.7437C8.81719 19.4062 8.73281 19.1109 8.52188 18.9422L8.4375 18.8578V18.5625C8.47969 18.0562 8.31094 17.5922 7.97344 17.2547C7.63594 16.875 7.12969 16.7062 6.58125 16.7062H6.24375C5.69531 16.7062 5.18906 16.9172 4.85156 17.2547C4.51406 17.5922 4.34531 18.0562 4.3875 18.5625V18.8578L4.30313 18.9422C4.09219 19.1109 4.00781 19.4062 4.09219 19.7437C4.13438 20.039 4.30313 20.4609 4.55625 20.6297L4.59844 20.6719V20.7562C4.68281 21.0937 4.85156 21.389 5.02031 21.6L5.14688 21.7687L5.0625 21.8953C4.64063 22.1484 4.05 22.4437 3.45938 22.6125C2.99531 22.739 2.65781 23.0344 2.40469 23.4984C2.3625 23.414 2.27813 23.3719 2.23594 23.2875C2.19375 23.2453 2.15156 23.1609 2.10938 23.1187C1.51875 22.275 1.18125 21.2203 1.18125 20.0812C1.18125 17.1703 3.58594 14.7656 6.49688 14.7656C9.45 14.7656 11.8125 17.1703 11.8125 20.0812C11.8125 21.1781 11.4328 22.2328 10.8422 23.1187Z"
            fill="white"
          />
          <path
            d="M20.5031 13.5844C16.9172 13.5844 14.0062 16.4953 14.0062 20.039C14.0062 21.8109 14.7234 23.414 15.8625 24.5531L15.9047 24.5953C17.0859 25.7765 18.689 26.4937 20.4609 26.4937C22.2328 26.4937 23.8781 25.7765 25.0594 24.5953C26.2406 23.414 25.1015 24.5531 25.1015 24.5531C25.1015 24.5531 25.1015 24.5531 25.1015 24.5109C26.325 23.414 27 21.8109 27 20.0812C27 16.4953 24.089 13.5844 20.5031 13.5844ZM24.764 23.2453C24.7219 23.3297 24.6375 23.3719 24.5953 23.4562C24.3422 23.0344 23.9625 22.739 23.4984 22.5703C22.9078 22.4015 22.3172 22.064 21.8953 21.8531L21.6844 21.7265L21.8109 21.5578C21.9797 21.3047 22.1062 21.0515 22.2328 20.714V20.6297L22.275 20.5875C22.5703 20.3765 22.6969 19.9125 22.739 19.7015C22.8234 19.3219 22.739 19.0687 22.5281 18.9L22.4437 18.8578V18.5625C22.4859 18.0562 22.3172 17.5922 21.9797 17.2547C21.6422 16.875 21.1359 16.7062 20.5875 16.7062H20.25C19.7015 16.7062 19.1953 16.9172 18.8578 17.2547C18.5203 17.5922 18.3515 18.0562 18.3937 18.5625V18.8578L18.3094 18.9422C18.0984 19.1109 18.014 19.364 18.0984 19.7437C18.1406 20.039 18.3094 20.4609 18.5625 20.6297L18.6047 20.6719V20.7562C18.689 21.0937 18.8578 21.389 19.0265 21.6L19.1531 21.7687L18.9422 21.8953C18.3515 22.2328 17.8031 22.4859 17.339 22.6125C16.875 22.739 16.5375 23.0344 16.2422 23.4984C16.2 23.414 16.1156 23.3719 16.0734 23.2875C15.6093 22.3594 15.1875 21.2625 15.1875 20.0812C15.1875 17.1703 17.5922 14.7656 20.5031 14.7656C23.4562 14.7656 25.8187 17.1703 25.8187 20.0812C25.8609 21.2625 25.439 22.3594 24.764 23.2453Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      label: "Interviewed Candidates",
      value: interviewed,
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5031 12.9938C24.089 12.9938 27 10.0828 27 6.49688C27 2.91094 24.089 0 20.5031 0C16.9172 0 14.0062 2.91094 14.0062 6.49688C14.0484 10.0828 16.9594 12.9938 20.5031 12.9938ZM20.5031 1.18125C23.4562 1.18125 25.8187 3.58594 25.8187 6.49688C25.8187 9.40781 23.414 11.8125 20.5031 11.8125C17.5922 11.8125 15.1875 9.40781 15.1875 6.49688C15.1875 3.58594 17.5922 1.18125 20.5031 1.18125Z"
            fill="white"
          />
          <path
            d="M6.49688 0.0422363C2.91094 0.0422363 0 2.91099 0 6.49692C0 8.2688 0.717188 9.82974 1.85625 11.011L1.89844 11.0532C3.07969 12.2344 4.68281 12.9516 6.45469 12.9516C8.26875 12.9516 9.87188 12.2344 11.0531 11.0532C12.1922 9.87192 12.9094 8.2688 12.9094 6.49692C12.9516 2.91099 10.0406 0.0422363 6.49688 0.0422363ZM10.8422 9.53442C10.8 9.57661 10.7578 9.66099 10.7156 9.70317C10.6734 9.78755 10.5891 9.82974 10.5469 9.91411C10.2938 9.49224 9.91406 9.19692 9.49219 9.02817C9.02813 8.90161 8.52188 8.64849 7.88906 8.31099L7.67813 8.18442L7.80469 8.01567C7.97344 7.76255 8.1 7.46724 8.22656 7.17192V7.08755L8.26875 7.04536C8.56406 6.83442 8.69063 6.41255 8.73281 6.15942C8.81719 5.82192 8.73281 5.52661 8.52188 5.35786L8.4375 5.27349V4.97817C8.47969 4.47192 8.31094 4.00786 7.97344 3.67036C7.63594 3.29067 7.12969 3.12192 6.58125 3.12192H6.24375C5.69531 3.12192 5.18906 3.33286 4.85156 3.67036C4.51406 4.00786 4.34531 4.47192 4.3875 4.97817V5.27349L4.30313 5.35786C4.09219 5.52661 4.00781 5.77974 4.09219 6.15942C4.13438 6.45474 4.30313 6.87661 4.55625 7.04536L4.59844 7.08755V7.17192C4.68281 7.50942 4.85156 7.80474 5.02031 8.01567L5.14688 8.18442L5.0625 8.31099C4.42969 8.64849 3.92344 8.90161 3.45938 9.02817C2.99531 9.15474 2.65781 9.45005 2.3625 9.91411C2.32031 9.82974 2.23594 9.78755 2.19375 9.70317C2.15156 9.66099 2.10938 9.57661 2.06719 9.53442C1.47656 8.69067 1.13906 7.63599 1.13906 6.49692C1.13906 3.5438 3.54375 1.1813 6.45469 1.1813C9.40781 1.1813 11.8125 3.58599 11.8125 6.49692C11.8125 7.63599 11.4328 8.64849 10.8422 9.53442Z"
            fill="white"
          />
          <path
            d="M6.49688 13.5844C2.91094 13.5844 0 16.4953 0 20.0812C0 21.8531 0.717188 23.414 1.81406 24.5953C1.81406 24.6375 1.85625 24.6375 1.89844 24.6797C3.07969 25.8609 4.68281 26.5781 6.45469 26.5781C8.22656 26.5781 9.87188 25.8609 11.0531 24.6797C12.2344 23.4984 11.0953 24.6375 11.0953 24.6375C11.0953 24.6375 11.0953 24.6375 11.0953 24.5953C12.2344 23.414 12.9094 21.8531 12.9094 20.0812C12.9516 16.4953 10.0406 13.5844 6.49688 13.5844ZM10.8422 23.1187C10.8 23.1609 10.7578 23.2453 10.7156 23.2875C10.6734 23.3719 10.5891 23.414 10.5469 23.4984C10.2938 23.0344 9.91406 22.739 9.49219 22.6125C8.90156 22.4437 8.31094 22.1062 7.88906 21.8953L7.67813 21.7687L7.80469 21.6C7.97344 21.3469 8.1 21.0937 8.22656 20.7562V20.6719L8.26875 20.6297C8.56406 20.4187 8.69063 19.9547 8.73281 19.7859V19.7437C8.81719 19.4062 8.73281 19.1109 8.52188 18.9422L8.4375 18.8578V18.5625C8.47969 18.0562 8.31094 17.5922 7.97344 17.2547C7.63594 16.875 7.12969 16.7062 6.58125 16.7062H6.24375C5.69531 16.7062 5.18906 16.9172 4.85156 17.2547C4.51406 17.5922 4.34531 18.0562 4.3875 18.5625V18.8578L4.30313 18.9422C4.09219 19.1109 4.00781 19.4062 4.09219 19.7437C4.13438 20.039 4.30313 20.4609 4.55625 20.6297L4.59844 20.6719V20.7562C4.68281 21.0937 4.85156 21.389 5.02031 21.6L5.14688 21.7687L5.0625 21.8953C4.64063 22.1484 4.05 22.4437 3.45938 22.6125C2.99531 22.739 2.65781 23.0344 2.40469 23.4984C2.3625 23.414 2.27813 23.3719 2.23594 23.2875C2.19375 23.2453 2.15156 23.1609 2.10938 23.1187C1.51875 22.275 1.18125 21.2203 1.18125 20.0812C1.18125 17.1703 3.58594 14.7656 6.49688 14.7656C9.45 14.7656 11.8125 17.1703 11.8125 20.0812C11.8125 21.1781 11.4328 22.2328 10.8422 23.1187Z"
            fill="white"
          />
          <path
            d="M20.5031 13.5844C16.9172 13.5844 14.0062 16.4953 14.0062 20.039C14.0062 21.8109 14.7234 23.414 15.8625 24.5531L15.9047 24.5953C17.0859 25.7765 18.689 26.4937 20.4609 26.4937C22.2328 26.4937 23.8781 25.7765 25.0594 24.5953C26.2406 23.414 25.1015 24.5531 25.1015 24.5531C25.1015 24.5531 25.1015 24.5531 25.1015 24.5109C26.325 23.414 27 21.8109 27 20.0812C27 16.4953 24.089 13.5844 20.5031 13.5844ZM24.764 23.2453C24.7219 23.3297 24.6375 23.3719 24.5953 23.4562C24.3422 23.0344 23.9625 22.739 23.4984 22.5703C22.9078 22.4015 22.3172 22.064 21.8953 21.8531L21.6844 21.7265L21.8109 21.5578C21.9797 21.3047 22.1062 21.0515 22.2328 20.714V20.6297L22.275 20.5875C22.5703 20.3765 22.6969 19.9125 22.739 19.7015C22.8234 19.3219 22.739 19.0687 22.5281 18.9L22.4437 18.8578V18.5625C22.4859 18.0562 22.3172 17.5922 21.9797 17.2547C21.6422 16.875 21.1359 16.7062 20.5875 16.7062H20.25C19.7015 16.7062 19.1953 16.9172 18.8578 17.2547C18.5203 17.5922 18.3515 18.0562 18.3937 18.5625V18.8578L18.3094 18.9422C18.0984 19.1109 18.014 19.364 18.0984 19.7437C18.1406 20.039 18.3094 20.4609 18.5625 20.6297L18.6047 20.6719V20.7562C18.689 21.0937 18.8578 21.389 19.0265 21.6L19.1531 21.7687L18.9422 21.8953C18.3515 22.2328 17.8031 22.4859 17.339 22.6125C16.875 22.739 16.5375 23.0344 16.2422 23.4984C16.2 23.414 16.1156 23.3719 16.0734 23.2875C15.6093 22.3594 15.1875 21.2625 15.1875 20.0812C15.1875 17.1703 17.5922 14.7656 20.5031 14.7656C23.4562 14.7656 25.8187 17.1703 25.8187 20.0812C25.8609 21.2625 25.439 22.3594 24.764 23.2453Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      label: "Onboarded Candidates",
      value: onboarded,
      icon: (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5031 12.9938C24.089 12.9938 27 10.0828 27 6.49688C27 2.91094 24.089 0 20.5031 0C16.9172 0 14.0062 2.91094 14.0062 6.49688C14.0484 10.0828 16.9594 12.9938 20.5031 12.9938ZM20.5031 1.18125C23.4562 1.18125 25.8187 3.58594 25.8187 6.49688C25.8187 9.40781 23.414 11.8125 20.5031 11.8125C17.5922 11.8125 15.1875 9.40781 15.1875 6.49688C15.1875 3.58594 17.5922 1.18125 20.5031 1.18125Z"
            fill="white"
          />
          <path
            d="M6.49688 0.0422363C2.91094 0.0422363 0 2.91099 0 6.49692C0 8.2688 0.717188 9.82974 1.85625 11.011L1.89844 11.0532C3.07969 12.2344 4.68281 12.9516 6.45469 12.9516C8.26875 12.9516 9.87188 12.2344 11.0531 11.0532C12.1922 9.87192 12.9094 8.2688 12.9094 6.49692C12.9516 2.91099 10.0406 0.0422363 6.49688 0.0422363ZM10.8422 9.53442C10.8 9.57661 10.7578 9.66099 10.7156 9.70317C10.6734 9.78755 10.5891 9.82974 10.5469 9.91411C10.2938 9.49224 9.91406 9.19692 9.49219 9.02817C9.02813 8.90161 8.52188 8.64849 7.88906 8.31099L7.67813 8.18442L7.80469 8.01567C7.97344 7.76255 8.1 7.46724 8.22656 7.17192V7.08755L8.26875 7.04536C8.56406 6.83442 8.69063 6.41255 8.73281 6.15942C8.81719 5.82192 8.73281 5.52661 8.52188 5.35786L8.4375 5.27349V4.97817C8.47969 4.47192 8.31094 4.00786 7.97344 3.67036C7.63594 3.29067 7.12969 3.12192 6.58125 3.12192H6.24375C5.69531 3.12192 5.18906 3.33286 4.85156 3.67036C4.51406 4.00786 4.34531 4.47192 4.3875 4.97817V5.27349L4.30313 5.35786C4.09219 5.52661 4.00781 5.77974 4.09219 6.15942C4.13438 6.45474 4.30313 6.87661 4.55625 7.04536L4.59844 7.08755V7.17192C4.68281 7.50942 4.85156 7.80474 5.02031 8.01567L5.14688 8.18442L5.0625 8.31099C4.42969 8.64849 3.92344 8.90161 3.45938 9.02817C2.99531 9.15474 2.65781 9.45005 2.3625 9.91411C2.32031 9.82974 2.23594 9.78755 2.19375 9.70317C2.15156 9.66099 2.10938 9.57661 2.06719 9.53442C1.47656 8.69067 1.13906 7.63599 1.13906 6.49692C1.13906 3.5438 3.54375 1.1813 6.45469 1.1813C9.40781 1.1813 11.8125 3.58599 11.8125 6.49692C11.8125 7.63599 11.4328 8.64849 10.8422 9.53442Z"
            fill="white"
          />
          <path
            d="M6.49688 13.5844C2.91094 13.5844 0 16.4953 0 20.0812C0 21.8531 0.717188 23.414 1.81406 24.5953C1.81406 24.6375 1.85625 24.6375 1.89844 24.6797C3.07969 25.8609 4.68281 26.5781 6.45469 26.5781C8.22656 26.5781 9.87188 25.8609 11.0531 24.6797C12.2344 23.4984 11.0953 24.6375 11.0953 24.6375C11.0953 24.6375 11.0953 24.6375 11.0953 24.5953C12.2344 23.414 12.9094 21.8531 12.9094 20.0812C12.9516 16.4953 10.0406 13.5844 6.49688 13.5844ZM10.8422 23.1187C10.8 23.1609 10.7578 23.2453 10.7156 23.2875C10.6734 23.3719 10.5891 23.414 10.5469 23.4984C10.2938 23.0344 9.91406 22.739 9.49219 22.6125C8.90156 22.4437 8.31094 22.1062 7.88906 21.8953L7.67813 21.7687L7.80469 21.6C7.97344 21.3469 8.1 21.0937 8.22656 20.7562V20.6719L8.26875 20.6297C8.56406 20.4187 8.69063 19.9547 8.73281 19.7859V19.7437C8.81719 19.4062 8.73281 19.1109 8.52188 18.9422L8.4375 18.8578V18.5625C8.47969 18.0562 8.31094 17.5922 7.97344 17.2547C7.63594 16.875 7.12969 16.7062 6.58125 16.7062H6.24375C5.69531 16.7062 5.18906 16.9172 4.85156 17.2547C4.51406 17.5922 4.34531 18.0562 4.3875 18.5625V18.8578L4.30313 18.9422C4.09219 19.1109 4.00781 19.4062 4.09219 19.7437C4.13438 20.039 4.30313 20.4609 4.55625 20.6297L4.59844 20.6719V20.7562C4.68281 21.0937 4.85156 21.389 5.02031 21.6L5.14688 21.7687L5.0625 21.8953C4.64063 22.1484 4.05 22.4437 3.45938 22.6125C2.99531 22.739 2.65781 23.0344 2.40469 23.4984C2.3625 23.414 2.27813 23.3719 2.23594 23.2875C2.19375 23.2453 2.15156 23.1609 2.10938 23.1187C1.51875 22.275 1.18125 21.2203 1.18125 20.0812C1.18125 17.1703 3.58594 14.7656 6.49688 14.7656C9.45 14.7656 11.8125 17.1703 11.8125 20.0812C11.8125 21.1781 11.4328 22.2328 10.8422 23.1187Z"
            fill="white"
          />
          <path
            d="M20.5031 13.5844C16.9172 13.5844 14.0062 16.4953 14.0062 20.039C14.0062 21.8109 14.7234 23.414 15.8625 24.5531L15.9047 24.5953C17.0859 25.7765 18.689 26.4937 20.4609 26.4937C22.2328 26.4937 23.8781 25.7765 25.0594 24.5953C26.2406 23.414 25.1015 24.5531 25.1015 24.5531C25.1015 24.5531 25.1015 24.5531 25.1015 24.5109C26.325 23.414 27 21.8109 27 20.0812C27 16.4953 24.089 13.5844 20.5031 13.5844ZM24.764 23.2453C24.7219 23.3297 24.6375 23.3719 24.5953 23.4562C24.3422 23.0344 23.9625 22.739 23.4984 22.5703C22.9078 22.4015 22.3172 22.064 21.8953 21.8531L21.6844 21.7265L21.8109 21.5578C21.9797 21.3047 22.1062 21.0515 22.2328 20.714V20.6297L22.275 20.5875C22.5703 20.3765 22.6969 19.9125 22.739 19.7015C22.8234 19.3219 22.739 19.0687 22.5281 18.9L22.4437 18.8578V18.5625C22.4859 18.0562 22.3172 17.5922 21.9797 17.2547C21.6422 16.875 21.1359 16.7062 20.5875 16.7062H20.25C19.7015 16.7062 19.1953 16.9172 18.8578 17.2547C18.5203 17.5922 18.3515 18.0562 18.3937 18.5625V18.8578L18.3094 18.9422C18.0984 19.1109 18.014 19.364 18.0984 19.7437C18.1406 20.039 18.3094 20.4609 18.5625 20.6297L18.6047 20.6719V20.7562C18.689 21.0937 18.8578 21.389 19.0265 21.6L19.1531 21.7687L18.9422 21.8953C18.3515 22.2328 17.8031 22.4859 17.339 22.6125C16.875 22.739 16.5375 23.0344 16.2422 23.4984C16.2 23.414 16.1156 23.3719 16.0734 23.2875C15.6093 22.3594 15.1875 21.2625 15.1875 20.0812C15.1875 17.1703 17.5922 14.7656 20.5031 14.7656C23.4562 14.7656 25.8187 17.1703 25.8187 20.0812C25.8609 21.2625 25.439 22.3594 24.764 23.2453Z"
            fill="white"
          />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    getDashboardData();
  }, []);

  //get api call
  const getDashboardData = async () => {
    const variables = {
      userId: isuser?.userid,
    };
    setLoader(true);
    try {
      if (user.roleName === "Admin") {
        const response = await postItem(GETDASHBOARDDATA);
        if (response?.filterAllData?.success === true) {
          setDashboardData(response?.filterAllData);
        } else {
          setDashboardData([]);
        }
      } else {
        const response = await postItem(GETDASHBOARDDATA, variables);
        if (response?.filterAllData?.success === true) {
          setDashboardData(response?.filterAllData);
        } else {
          setDashboardData([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const filterSubmit = async () => {
    const variables = {
      startDate: filterData.fromDate,
      endDate: filterData.toDate,
      userId: isuser.userid,
    };
    setLoader(true);
    try {
      setIsFilter(true)
      const response = await postItem(GETDASHBOARDDATA, variables);
      if (response?.filterAllData?.success === true) {
        setshowbutton(true);
        setDashboardData(response?.filterAllData);
        setFileterdownloadurl(response?.filterAllData?.downloadUrl)
        setFileterdownloadurlCSV(response?.filterAllData?.downloadPdfUrl)
      } else {
        setDashboardData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      filterClose();
      setLoader(false);
    }
  };

  const hanldereset = () => {
    getDashboardData();
    resetForm();
    setshowbutton(false);
    setIsFilter(false)
    setFileterdownloadurl('')
    setFileterdownloadurlCSV('')
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      setOpenFilter={setOpenFilter}
      name="DashBoard"
    >
      {Loader && <LoadingSpinner />}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Dashboard"
        isFilter={isFilter}
        fileterdownloadurl={fileterdownloadurl}
        fileterdownloadurlCSV={fileterdownloadurlCSV}
      />
      <FilterDialog
        open={openFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        onClose={FormClosewithreset}
        setPopup={setPopup}
        data={exportData}
        filterSubmit={filterSubmit}
      />
      <Box minHeight="100vh" mt={2} px={2}>
        {showbutton && (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginBottom: "1%",
              marginRight: "2%",
            }}
          >
            <Tooltip title="Reset Filter" placement="top">
              <IconButton
                onClick={hanldereset}
                sx={{ fontSize: "25px", background: colors.buttonColor, mr: 1 }}
              >
                <RestartAltIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Tooltip>
          </div>
        )}
        <Grid container spacing={1}>
          {stats.map((stat, index) => (
            <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index} px={3}>
              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for elevation
                  height: "100%", // Ensures consistent height
                  width: "100%", // Ensures consistent width
                }}
                className="stat-card"
              >
                <div>
                  <Typography
                    style={{
                      fontSize: "14px",
                      color: "#7C71BA",
                      fontWeight: "bold",
                    }}
                  >
                    {stat.label}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "26px",
                      color: "#7C71BA",
                      fontWeight: "bold",
                    }}
                  >
                    {stat.value}
                  </Typography>
                </div>
                <IconButton
                  style={{
                    backgroundColor: "#6D61B1",
                    height: "50px",
                    width: "50px",
                    animation: "spin 1s linear",
                  }}
                  className="icon-button"
                >
                  {stat.icon}
                </IconButton>
                <style>
                  {`
          .stat-card {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Default shadow */
          }

          .stat-card:hover {
            transform: translateY(-3px); /* Lift the card */
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2); /* Enhanced shadow */
          }

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
                </style>
              </div>
            </Grid>
          ))}
        </Grid>
        {/* Chart and Notices Section */}
        <Grid container spacing={3} mt={3}>
          {/* Chart */}
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <MonthlySelectionTrends dashboardData={dashboardData} />
          </Grid>

          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <DashBoardCandidateChart dashboardData={dashboardData} />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <TeamContribution />
          </Grid> */}
        </Grid>
        {/* <Box mt={3}>
          <UserSummary />
        </Box> */}
      </Box>
    </DashboardLayout>
  );
};

export default Dashboard;
